var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28125 7.04539L6.49742 1.82922L9.16731 4.49912L3.95114 9.71529L1.28125 7.04539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0539067 9.9856C-0.155864 10.7198 0.263677 11.1568 1.01536 10.9471L3.41024 10.2653L0.735661 7.57324L0.0539067 9.9856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6993 1.49025L9.51061 0.301545C9.10855 -0.100515 8.44427 -0.100515 8.02473 0.301545L7.02832 1.29796L9.7029 3.97253L10.6993 2.97612C11.1188 2.55658 11.1188 1.89231 10.6993 1.49025Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.90d127750c9d61305decf7e5961656df.svg";
export { ForwardRef as ReactComponent };